import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cx-order-confirmation-thank-you-message',
  templateUrl: './custom-order-confirmation-thank-you-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomOrderConfirmationThankYouMessageComponent {

}
